export const STORAGE_KEY = 'FRANKENSTEIN';

// записать текущее состояние в локальное хранилище
export default function subscribeRecord(store) {
  store.subscribe(() => {
    let data = store.getState();
    data = JSON.stringify(data);
    data = encodeURIComponent(data);
    localStorage.setItem(STORAGE_KEY, data);
  });
}
